// start:ng42.barrel
export * from './routes.config';
export * from './rfids';

export { default as MONA_CONFIG_DEFAULT } from './mona-config.json';
export { default as WEBRTC_CONFIG_DEFAULT } from './webrtc-config.json';

export const MONA_CONFIG_FILENAME = 'mona-config.json';
// end:ng42.barrel
